
$(document).on("click", "a[href='#none']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-steps-js.hk-active').scrollIntoView({
    behavior: 'smooth'
  })
});

var urlParams = new URLSearchParams(window.location.search);

var required_quantity = parseInt(urlParams.get('quantity') || '2', 10);
var required_sellingPlan = urlParams.get('selling_plan') !== 'false';
var prevPage = urlParams.get('prev_page') || '';

$(document).ready(function(){
if (prevPage !== '') {
    $('.hk-back-button a').attr('href', prevPage);
}
if (required_quantity > 1){
$('.hk-pdt-disabled .hk-button').html('Select atleast '+required_quantity+' scents <strong>→</strong>');
$('.hk-header-heading .hk-element-heading').text('Select at least '+required_quantity+' pairs');
} else {
$('.hk-pdt-disabled .hk-button').html('Select atleast '+required_quantity+' scent <strong>→</strong>');  
$('.hk-header-heading .hk-element-heading').text('Select at least '+required_quantity+' pair');
}

});

$(document).on("click", ".hk-element-sub-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-sub-option').removeClass('hk-active');
$(this).addClass('hk-active');
var sub_tab = $(this).attr('sub_tab');
$(this).parents('.hk-product').find('.hk-sub-trigger').hide().removeClass('hk-active');
$(this).parents('.hk-product').find('.hk-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('hk-active');
});

$(document).on("click", ".hk-add-lp-cart-variant-js:not([disabled])", function(e) {
$(this).parents('.hk-product-variant-right').addClass('hk-active');
$(this).parents('.hk-product-variant-right').find('input').val('1').trigger('change');
});
$(document).on("change", ".hk-product-variant-right input", function(e) {
update_step();
});

$(document).on('click', '.hk-quantity-plus-lp-cart:not([disabled])', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;
    $input.val(qty + 1).trigger('change');
update_step();
});

$(document).on('click', '.hk-quantity-minus-lp-cart', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;

    if (qty > 0) {
        $input.val(qty - 1).trigger('change');
    }
    if (qty == 1) {
       $input.parents('.hk-product-variant-right').removeClass('hk-active');
    }
update_step();
});


function update_step() {
var current_step = $('.hk-steps-js.hk-active');
var quantity = 0;
current_step.find('.hk-product-variant-right input').each(function(){
quantity = quantity + parseInt($(this).val());
});
current_step.find('.hk-lp-cart-top-step').removeClass('hk-active');
current_step.find('.hk-quantity-plus-lp-cart').removeAttr('disabled');
current_step.find('.hk-add-lp-cart-variant-js').removeAttr('disabled');
var width = 0;

if(quantity >= 1){
//$('.hk-element-free-gift').addClass('hk-active');
} else {
//$('.hk-element-free-gift').removeClass('hk-active');
}

if(quantity >= required_quantity){
$('.hk-pdt-disabled').hide();
$('.hk-pdt-btn-final').show();
} else {
$('.hk-pdt-disabled').show();
$('.hk-pdt-btn-final').hide();
}



if(quantity >= 999){
current_step.find('.hk-quantity-plus-lp-cart').attr('disabled','disabled');
current_step.find('.hk-add-lp-cart-variant-js').attr('disabled','disabled');
}


}






$(document).on("click", "a[href='#cart']", function (e) {
  e.preventDefault();
  var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;
  $btn.addClass('hk-loading');

  var items = [];
var total1 = 0;
$('.hk-steps-js1 input.hk-lp-cart-quantity').each(function(){
 total1 = total1 + parseInt($(this).val());
});
if(total1 == 1) {
  var selling_plan1 = $('.hk-steps-js1').attr('selling_plan1');
}
if(total1 == 2) {
  var selling_plan1 = $('.hk-steps-js1').attr('selling_plan2');
}
if(total1 == 3) {
  var selling_plan1 = $('.hk-steps-js1').attr('selling_plan3');
}
if(total1 >= 4) {
  var selling_plan1 = $('.hk-steps-js1').attr('selling_plan4');
}

$('.hk-steps-js1 input.hk-lp-cart-quantity').each(function(){
var quantity = parseInt($(this).val());
var variant_id = $(this).attr('variant_id1');
if(quantity > 0){
var item = {
    id: parseInt(variant_id),
    quantity: quantity
  };
if (selling_plan1 && required_sellingPlan == true) {
    item.selling_plan = parseInt(selling_plan1);
  }
  items.push(item);
}
});

$('.hk-element-free-gift:not(:last-child)').each(function(){
var quantity = 1;
var variant_id = $(this).attr('variant_id');
var item = {
    id: parseInt(variant_id),
    quantity: quantity
  };
  items.push(item);
});


  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function () {
    
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },
    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        
      //refreshCartDrawer_cart();
    //$('.hk-cart-drawer').addClass('active');
    //$('.hk-drawer-cart-bg').show();
    //$('body').addClass('hk-overflow-hidden');
    location.href="/checkout";
      }, 500);
    }
  });
    }
});

});








function refreshCartDrawer_cart() {
  $.get(window.location.href, function (response) {
    var newContent = $(response).find('.hk-cart-drawer-js').html();
    $('.hk-cart-drawer-js').html(newContent);
    $('.hk-cart-drawer-js').removeClass('hk-loading-cart');
    document.querySelectorAll('.hk-element-related-grid.hk-slick-slider[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });
  });
  
}